import axios from 'axios'
import { toast } from 'react-toastify'
import { I18n } from 'react-redux-i18n'

import { showNotification } from '../../redux/actions/showNotification'
import { showFlowError } from '../../redux/flowErrors/actions'
import { store } from '../../redux'
import { nxAuthTokenAct } from 'redux_new/actions'


// Add a response interceptor
axios.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response
  },
  async function (error) {
    if (error.response) {
      const { response = {}, config } = error
      const { status, data } = response

      switch (status) {
        case 400: {
          if (data.type === 'flow') {
            store.dispatch(showFlowError(data, config))
          }

          break
        }
        case 401:
          store.dispatch({ type: 'USER_LOGOUT' })

          break
        case 402:
          // Popup con lo enlace con el boton de cancel y de ir a metodo de pago sin timeout body: I18n.t('errors_payment_not_updated')
          store.dispatch(showNotification(true, data.type, data.error))
          break
        case 403:
        case 404: {
          toast(I18n.t(data.type || 'error_not_have_permissions'), { autoClose: 4000 })
          break
        }
        case 440:{
          const { result, token } = await store.dispatch(nxAuthTokenAct.tokenRefresh())

          if (result) {
            config.headers['nx-auth-token'] = token
            return axios.request(config)
          }else{
            store.dispatch({ type: 'USER_LOGOUT' })
          }

          break
        }
        default:
          // console.error(JSON.stringify(error))
          break
      }
    }

    return Promise.reject(error)
  }
)
